import {
  createDataCollection as publicCreateDataCollection,
  getDataCollection as publicGetDataCollection,
  listDataCollections as publicListDataCollections,
  updateDataCollection as publicUpdateDataCollection,
  deleteDataCollection as publicDeleteDataCollection,
  restoreDataCollection as publicRestoreDataCollection,
  patchDataCollection as publicPatchDataCollection,
  createDataCollectionField as publicCreateDataCollectionField,
  updateDataCollectionField as publicUpdateDataCollectionField,
  deleteDataCollectionField as publicDeleteDataCollectionField,
  addDataCollectionPlugin as publicAddDataCollectionPlugin,
  deleteDataCollectionPlugin as publicDeleteDataCollectionPlugin,
  patchDataCollectionField as publicPatchDataCollectionField,
} from './data-v2-data-collection-collections.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const createDataCollection: MaybeContext<
  BuildRESTFunction<typeof publicCreateDataCollection> &
    typeof publicCreateDataCollection
> = /*#__PURE__*/ createRESTModule(publicCreateDataCollection);
export const getDataCollection: MaybeContext<
  BuildRESTFunction<typeof publicGetDataCollection> &
    typeof publicGetDataCollection
> = /*#__PURE__*/ createRESTModule(publicGetDataCollection);
export const listDataCollections: MaybeContext<
  BuildRESTFunction<typeof publicListDataCollections> &
    typeof publicListDataCollections
> = /*#__PURE__*/ createRESTModule(publicListDataCollections);
export const updateDataCollection: MaybeContext<
  BuildRESTFunction<typeof publicUpdateDataCollection> &
    typeof publicUpdateDataCollection
> = /*#__PURE__*/ createRESTModule(publicUpdateDataCollection);
export const deleteDataCollection: MaybeContext<
  BuildRESTFunction<typeof publicDeleteDataCollection> &
    typeof publicDeleteDataCollection
> = /*#__PURE__*/ createRESTModule(publicDeleteDataCollection);
/** @internal */
export const restoreDataCollection: MaybeContext<
  BuildRESTFunction<typeof publicRestoreDataCollection> &
    typeof publicRestoreDataCollection
> = /*#__PURE__*/ createRESTModule(publicRestoreDataCollection);
export const patchDataCollection: MaybeContext<
  BuildRESTFunction<typeof publicPatchDataCollection> &
    typeof publicPatchDataCollection
> = /*#__PURE__*/ createRESTModule(publicPatchDataCollection);
export const createDataCollectionField: MaybeContext<
  BuildRESTFunction<typeof publicCreateDataCollectionField> &
    typeof publicCreateDataCollectionField
> = /*#__PURE__*/ createRESTModule(publicCreateDataCollectionField);
export const updateDataCollectionField: MaybeContext<
  BuildRESTFunction<typeof publicUpdateDataCollectionField> &
    typeof publicUpdateDataCollectionField
> = /*#__PURE__*/ createRESTModule(publicUpdateDataCollectionField);
export const deleteDataCollectionField: MaybeContext<
  BuildRESTFunction<typeof publicDeleteDataCollectionField> &
    typeof publicDeleteDataCollectionField
> = /*#__PURE__*/ createRESTModule(publicDeleteDataCollectionField);
export const addDataCollectionPlugin: MaybeContext<
  BuildRESTFunction<typeof publicAddDataCollectionPlugin> &
    typeof publicAddDataCollectionPlugin
> = /*#__PURE__*/ createRESTModule(publicAddDataCollectionPlugin);
export const deleteDataCollectionPlugin: MaybeContext<
  BuildRESTFunction<typeof publicDeleteDataCollectionPlugin> &
    typeof publicDeleteDataCollectionPlugin
> = /*#__PURE__*/ createRESTModule(publicDeleteDataCollectionPlugin);
export const patchDataCollectionField: MaybeContext<
  BuildRESTFunction<typeof publicPatchDataCollectionField> &
    typeof publicPatchDataCollectionField
> = /*#__PURE__*/ createRESTModule(publicPatchDataCollectionField);

export {
  CollectionType,
  Direction,
  DataOperation,
  CollectionOperation,
  Type,
  QueryOperator,
  PageLinkType,
  FieldPluginType,
  Permission,
  Role,
  Status,
  Format,
  PluginType,
  PagingMode,
  AccessLevel,
  Segment,
  SortOrder,
  TenantMode,
  Order,
  IndexStatus,
  IndexSource,
  WebhookIdentityType,
} from './data-v2-data-collection-collections.universal.js';
export {
  DataCollection,
  Sort,
  CollectionCapabilities,
  IndexLimits,
  IndexQuotaLimits,
  Field,
  FieldRangeValidationsOneOf,
  TextValidation,
  EnumValues,
  TypeMetadata,
  TypeMetadataMetadataOneOf,
  FieldCapabilities,
  ObjectField,
  FieldsPattern,
  UrlizedOnlyPattern,
  Calculator,
  CalculatorPatternOneOf,
  Reference,
  MultiReference,
  _Object,
  _Array,
  PageLink,
  Slug,
  Text,
  TextValidationOneOf,
  _Number,
  _Date,
  _DateDefaultValueOneOf,
  _DateMinDateOneOf,
  _DateMaxDateOneOf,
  Datetime,
  DatetimeDefaultValueOneOf,
  DatetimeMinDateOneOf,
  DatetimeMaxDateOneOf,
  Image,
  _Boolean,
  Document,
  Url,
  RichText,
  Video,
  ArrayString,
  ArrayDocument,
  Audio,
  Time,
  RichContent,
  MediaGallery,
  Address,
  Email,
  LegacyColor,
  NumberRange,
  StringLengthRange,
  ArraySizeRange,
  FieldPlugin,
  FieldPluginOptionsOneOf,
  CmsOptions,
  CategoryFieldOptions,
  FieldCondition,
  Permissions,
  Plugin,
  PluginOptionsOneOf,
  SiteSort,
  PublishPluginOptions,
  SingleItemPluginOptions,
  UrlizedPluginOptions,
  MultilingualOptions,
  PageLinkPluginOptions,
  PluginCmsOptions,
  CatalogOptions,
  DataPermissions,
  AllowedDataPermissions,
  DataCollectionClonedEvent,
  DataCollectionChangedEvent,
  FieldUpdate,
  PluginUpdate,
  PermissionsUpdate,
  StrictModeUpdate,
  DataCollectionEvictedEvent,
  CreateDataCollectionRequest,
  CreateDataCollectionResponse,
  GetDataCollectionRequest,
  GetDataCollectionResponse,
  ListDataCollectionsRequest,
  Sorting,
  Paging,
  ListDataCollectionsResponse,
  PagingMetadataV2,
  BulkGetDataCollectionsRequest,
  BulkGetDataCollectionsResponse,
  ApplicationError,
  FailedCollection,
  UpdateDataCollectionRequest,
  UpdateDataCollectionResponse,
  DeleteDataCollectionRequest,
  DeleteDataCollectionResponse,
  RestoreDataCollectionRequest,
  RestoreDataCollectionResponse,
  PatchDataCollectionRequest,
  PatchDataCollectionResponse,
  CreateDataCollectionFieldRequest,
  CreateDataCollectionFieldResponse,
  UpdateDataCollectionFieldRequest,
  UpdateDataCollectionFieldResponse,
  DeleteDataCollectionFieldRequest,
  DeleteDataCollectionFieldResponse,
  AddDataCollectionPluginRequest,
  AddDataCollectionPluginResponse,
  DeleteDataCollectionPluginRequest,
  DeleteDataCollectionPluginResponse,
  PatchDataCollectionFieldRequest,
  PatchDataCollectionFieldResponse,
  UpdateDataPermissionsRequest,
  UpdateDataPermissionsResponse,
  BulkGetDataCollectionsPageBySnapshotsRequest,
  BulkGetDataCollectionsPageBySnapshotsRequestTenantModeOptionsOneOf,
  AppOptions,
  BulkGetDataCollectionsPageBySnapshotsResponse,
  SnapshotCollection,
  Index,
  IndexField,
  Failure,
  CreateDataCollectionsSnapshotRequest,
  CreateDataCollectionsSnapshotResponse,
  CreateAppCollectionsSnapshotRequest,
  CollectionDefinition,
  CreateAppCollectionsSnapshotResponse,
  RestoreDataCollectionsFromSnapshotRequest,
  Destination,
  RestorationCollection,
  RestoreDataCollectionsFromSnapshotResponse,
  DeleteDataCollectionsSnapshotRequest,
  DeleteDataCollectionsSnapshotResponse,
  CreateMigratedCollectionsSnapshotRequest,
  CreateMigratedCollectionsSnapshotResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  GetDataCollectionOptions,
  ListDataCollectionsOptions,
  PatchDataCollection,
  CreateDataCollectionFieldOptions,
  UpdateDataCollectionFieldOptions,
  DeleteDataCollectionFieldOptions,
  AddDataCollectionPluginOptions,
  DeleteDataCollectionPluginOptions,
} from './data-v2-data-collection-collections.universal.js';
export {
  CollectionTypeWithLiterals,
  DirectionWithLiterals,
  DataOperationWithLiterals,
  CollectionOperationWithLiterals,
  TypeWithLiterals,
  QueryOperatorWithLiterals,
  PageLinkTypeWithLiterals,
  FieldPluginTypeWithLiterals,
  PermissionWithLiterals,
  RoleWithLiterals,
  StatusWithLiterals,
  FormatWithLiterals,
  PluginTypeWithLiterals,
  PagingModeWithLiterals,
  AccessLevelWithLiterals,
  SegmentWithLiterals,
  SortOrderWithLiterals,
  TenantModeWithLiterals,
  OrderWithLiterals,
  IndexStatusWithLiterals,
  IndexSourceWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './data-v2-data-collection-collections.universal.js';
